// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import useLoading from "hooks/use-loading";
import { verifyEmail } from "tutor/services/password-service";

function Cover() {
  const { setShowLoader } = useLoading();

  const { token } = useParams();

  const navigate = useNavigate();

  const [responseHasError, setResponseHasError] = useState(false);
  const [responseErrorMessage, setResponseErrorMessage] = useState("");

  const [isVerified, setIsVerified] = useState(false);

  const requestVerifyEmail = async () => {
    setShowLoader(true);
    const res = await verifyEmail(token);
    try {
      if (res.status) {
        setIsVerified(true);
        setResponseHasError(false);
        setResponseErrorMessage("");
      } else {
        setResponseHasError(true);
        setResponseErrorMessage(res.message);
      }
    } catch (e) {
      // console.log(e);
      setResponseHasError(true);
      setResponseErrorMessage("Something went wrong");
    }
    setShowLoader(false);
  };

  useEffect(() => {
    requestVerifyEmail();
  }, []);

  return (
    <CoverLayout coverHeight="50vh" image={bgImage}>
      <Card>
        <MDBox pt={4} pb={3} px={3}>
          {responseHasError && (
            <MDTypography variant="h6" fontWeight="medium" color="error">
              {responseErrorMessage}
            </MDTypography>
          )}
          {isVerified && (
            <>
              <MDTypography variant="h6" fontWeight="medium" color="success">
                Email verified successfully!
              </MDTypography>
              <MDButton onClick={() => navigate("/authentication/sign-in")}>Sign In</MDButton>
            </>
          )}
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
